import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/renren': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M214 169.1c0 110.4-61 205.4-147.6 247.4-36.4-43.3-58.4-98.8-58.4-159.9 0-122.7 89.1-224.4 206-244.1v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4 57.2-36.1 103.4-90.7 118.5-154.6 15.5 63.9 61.7 118.5 118.8 154.7-35.1 19.3-75.5 30.3-118.8 30.3zM445.6 416.5c-86.6-42-147.6-136.9-147.6-247.4v-156.6c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/renren.js
// module id = 992
// module chunks = 0